module.exports = __webpack_public_path__ + "static/img/26.6712125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/26.jpg
// module id = OQub
// module chunks = 16